import React, { useEffect, useState } from "react";
import { api, wsUrl } from "@/lib/api";
import { Link } from "react-router-dom";
import { MessagesSquare } from "lucide-react";

export default function ChatTicker() {
  const [msgs, setMsgs] = useState([]);

  useEffect(() => {
    const load = () => api.get("/chat/global?limit=20").then(({ data }) => setMsgs(data.reverse())).catch(() => {});
    load();
    const i = setInterval(load, 15000);
    let ws;
    try {
      ws = new WebSocket(wsUrl("/api/ws/tv"));
      ws.onmessage = (e) => {
        try {
          const ev = JSON.parse(e.data);
          if (ev.type === "chat.global") setMsgs((m) => [ev.msg, ...m].slice(0, 20));
        } catch {}
      };
    } catch {}
    return () => { clearInterval(i); if (ws) ws.close(); };
  }, []);

  if (msgs.length === 0) return null;

  // Duplicate for seamless loop
  const stream = [...msgs, ...msgs];

  return (
    <div className="bg-gradient-to-r from-black via-[#0a0a14] to-black border-b border-amber-500/15 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 flex items-center gap-3 h-8">
        <Link to="/community" className="shrink-0 flex items-center gap-1.5 text-[10px] uppercase tracking-widest font-display font-bold text-amber-300 hover:text-amber-200" data-testid="chat-ticker-label">
          <MessagesSquare size={11} /> Chat tổng
        </Link>
        <div className="flex-1 relative overflow-hidden h-full">
          <div className="absolute inset-y-0 flex items-center gap-8 whitespace-nowrap animate-ticker">
            {stream.map((m, i) => {
              const isSystem = m.is_system || m.room_type === "system";
              return (
                <Link key={`${m.id}-${i}`} to={m.arena_request_id ? `/arena/${m.arena_request_id}` : "/community"} className="inline-flex items-center gap-2 text-xs hover:opacity-80">
                  {isSystem ? (
                    <span className="text-amber-300 font-semibold">{m.message}</span>
                  ) : (
                    <>
                      {m.sender_avatar && <img src={m.sender_avatar} alt="" className="w-4 h-4 rounded-full" />}
                      <span className="text-white/60 font-medium">{m.sender_nickname}:</span>
                      <span className="text-white/85">{m.message}</span>
                    </>
                  )}
                </Link>
              );
            })}
          </div>
        </div>
      </div>
      <style>{`
        @keyframes ticker {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        .animate-ticker { animation: ticker 60s linear infinite; }
        .animate-ticker:hover { animation-play-state: paused; }
      `}</style>
    </div>
  );
}
